// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Lx9e","inputWrap":"CustomTip_inputWrap__3PzrO"};